import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { executeRegistrationPayment } from '../services/api';

const PaymentSuccess = () => {
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    const location = useLocation();

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const registrationId = urlParams.get('registrationId');
        const paymentId = urlParams.get('paymentId');
        const payerId = urlParams.get('PayerID');

        if (registrationId && paymentId && payerId) {
            executePayment(registrationId, paymentId, payerId);
        } else {
            setMessage('Payment completed successfully!');
            setLoading(false);
        }
    }, [location]);

    const executePayment = async (registrationId, paymentId, payerId) => {
        try {
            const result = await executeRegistrationPayment(registrationId, paymentId, payerId);
            setMessage(result.message || 'Payment completed successfully!');
        } catch (error) {
            console.error('Payment execution error:', error);
            setMessage(`Payment processing error: ${error.response?.data?.message || error.message || 'Error processing payment. Please contact support.'}`);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="container py-5">
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Processing payment...</span>
                    </div>
                    <p className="mt-3">Processing your payment...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card">
                        <div className="card-body text-center">
                            <div className="mb-4">
                                <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '4rem' }}></i>
                            </div>
                            <h2 className="card-title text-success">Payment Successful!</h2>
                            <p className="card-text">{message}</p>
                            <div className="mt-4">
                                <a href="/dashboard" className="btn btn-primary me-3">
                                    View My Registrations
                                </a>
                                <a href="/" className="btn btn-outline-secondary">
                                    Return Home
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;
